import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { Card, Button } from 'reactstrap';
import Stepper from 'components/Stepper';
import calendar from '../../../assets/img/calendar.png';
import calendarError from '../../../assets/img/calendar_error.png';
import simpleLineIconsCheck from '../../../assets/img/simple-line-icons_check.png';
import simpleLineIconsError from '../../../assets/img/simple-line-icons_error.png';
import { Calendar, MapPin } from 'lucide-react';
import { postTurnosJura } from '../../../features/matriculas/matriculasAPI';
import { getSolicitudMatricula } from '../../../features/matriculas/matriculasAPI';
import { MatriculaRequest } from 'types/Matriculas';

interface PaymentReturnProps extends RouteComponentProps<any, any, any> {}

const PaymentReturn: React.FC<PaymentReturnProps> = () => {
  const location = useLocation();
  const history = useHistory();

  const [matriculacion, setMatriculacion] = useState<Partial<MatriculaRequest>>({
    state_id: 0,
  });

  const [paymentStatus, setPaymentStatus] = useState<number | undefined>();

  const handleGoToDashboard = () => {
    history.push('/inicio');
  };

  const handleCancelarTurno = async (e: React.FormEvent) => {
    e.preventDefault();

    const response = await postTurnosJura({
      id: null,
      lugar: null,
      fecha_hora: null,
    });

    if (response && response.status == 'ok') {
      history.push('/inicio');
    } else {
      alert(
        'Ocurrió un error al intentar cancelar su turno. ' +
          'Por favor, intente nuevamente más tarde.',
      );
    }
  };

  useEffect(() => {
    if (location.pathname.includes('/pago-exitoso')) {
      setPaymentStatus(1);
    } else if (location.pathname.includes('/pago-fallido')) {
      setPaymentStatus(2);
    } else if (location.pathname.includes('/pago-pendiente')) {
      setPaymentStatus(3);
    }
  }, [location.pathname]);

  useEffect(() => {
    const loadData = async () => {
      try {
        const solicitudMatriculaResponse = await getSolicitudMatricula();
        if (solicitudMatriculaResponse) {
          setMatriculacion(solicitudMatriculaResponse);
        }
      } catch (err) {
        alert(
          'Se produjo un error al intentar recuperar información inicial. ' +
            'Por favor, intente nuevamente más tarde.',
        );
        console.error('Home', 'Error al cargar datos iniciales');
        console.info(err);
      } finally {}
    };

    loadData();
  }, []);

  return (
    <div>
      <Card
        style={{ padding: '1rem 15rem', display: 'flex', alignItems: 'center' }}
        className='max-w-4xl mx-auto bg-white shadow-md rounded-2xl p-8'
      >
        {/* Stepper */}
        <Stepper
          currentStep={3}
          steps={['Fecha y Hora', 'Pago Matrícula']}
          title='Programación de jura presencial'
        />
        <>
          <>
            <img
              src={paymentStatus === 1 || paymentStatus === 3 ? calendar : calendarError}
              alt='calendario'
              className='img-fluid mb-4'
              style={{ maxWidth: '195px' }}
            />
            <img
              src={paymentStatus === 1 || paymentStatus === 3 ? simpleLineIconsCheck : simpleLineIconsError}
              alt={paymentStatus === 1 || paymentStatus === 3 ? 'check' : 'error'}
              className='img-fluid mb-4'
              style={{ maxWidth: '50px' }}
            />
          </>

          <p
            style={{
              fontWeight: 'medium',
              fontSize: 26,
              marginBottom: '0.5rem',
            }}
            className='mt-4 font-semibold'
          >
            { paymentStatus === 1
              ? 'Se programó el turno de jura'
              : paymentStatus === 3
                ? 'Pago pendiente de acreditación'
                : 'Se detectó un problema en el proceso'
            }
          </p>
          <p
            style={{
              fontWeight: 'medium',
              fontSize: 16,
              marginBottom: '1.5rem',
            }}
            className='mt-4 font-semibold'
          >
            { paymentStatus === 1
              ? 'Tu turno de jura quedó confirmado.'
              : paymentStatus === 3
                ? 'Tu pago está siendo procesado. Una vez acreditado tu turno quedará confirmado.'
                : 'Hubo un problema con el pago. Por favor, intentá nuevamente más tarde.'
            }
          </p>
          { paymentStatus === 1
            ?
              <div
                style={{
                  border: '1px solid gray',
                  padding: '0.5rem 1rem',
                  borderRadius: 5,
                }}
              >
                <p style={{ marginBottom: '5px' }}>
                  <Calendar color='#9123C0' style={{ marginRight: '5px' }} />
                  <strong>Día {matriculacion.tj_fecha_hora}hs</strong>
                </p>
                <div style={{ display: 'flex' }}>
                  <MapPin color='#9123C0' style={{ marginRight: '5px' }} />
                  <p style={{ marginBottom: 0 }}>{matriculacion.tj_lugar}</p>
                </div>
              </div>
            : null
          }
          <Button
            className='btn-custom'
            style={{ marginTop: '10rem' }}
            color='primary'
            onClick={handleGoToDashboard}
          >
            Inicio
          </Button>
          <Button
            className='btn btn-secondary bg-transparent text-uppercase text-primary fw-bold d-flex align-items-center'
            style={{ textDecoration: 'underline' }}
            color='primary'
            onClick={handleCancelarTurno}
          >
            Cancelar turno
          </Button>
        </>
      </Card>
    </div>
  );
};

export default PaymentReturn;
